"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
function default_1(project, printableId) {
  const printableGroup = project.printableGroups.find(pg => !!pg.printables.find(p => p.id === printableId));
  return !!(printableGroup === null || printableGroup === void 0 ? void 0 : printableGroup.rotateWorkspace);
}